import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page centered" }

import LoginForm from '@/components/user/LoginForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(LoginForm)
  ]))
}
}

})